<template>
  <div>
    <ContentHeader :stock-nav="true" :show-back="false" />

    <div class="content-container">
      <div class="query-panel">
        <div class="btn-line btn-line-right">
          <el-button
            class="btn-orange-plain"
            @click="searchStockCart"
            size="small"
            >查看领用购物车</el-button
          >
          <el-button
            class="btn-orange-plain"
            @click="goToQuotaOrder"
            size="small"
            >查看领用订单</el-button
          >
        </div>
        <!-- 查询条件 -->
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="queryParam.itemName"
                  placeholder="请输入商品名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                /> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="配额名称">
                <el-input
                  v-model="queryParam.quotaName"
                  placeholder="请输入配额名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseIds"
                  placeholder="请选择所在仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="查询日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.fromDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="startTimeStatus"
                    clearable
                    :picker-options="pickerOptionsStart"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.toDate"
                    type="date"
                    placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="endTimeStatus"
                    clearable
                    :picker-options="pickerOptionsEnd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
          <!-- <el-button
            class="btn-orange-plain"
            @click="searchStockCart"
            size="small"
            >查看领用购物车</el-button
          >
          <el-button
            class="btn-orange-plain"
            @click="goToQuotaOrder"
            size="small"
            >查看领用订单</el-button
          > -->
        </div>
      </div>

      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table
          :data="quotaList"
          class="while-data-table"
          v-loading="loading"
        >
          <el-table-column label="图片">
            <template slot-scope="scope">
              <div class="item-image" @click="handleViewPic(scope.row)">
                <img :src="getImageUrl(scope.row)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="itemName" />
          <el-table-column
            prop="quotaDTO.quotaName"
            label="配额名称"
          ></el-table-column>
          <!-- <el-table-column
            prop="quotaDTO.quotaCode"
            label="配额编码"
          ></el-table-column> -->
          <el-table-column
            prop="totalQuota"
            label="全部配额"
          ></el-table-column>
          <el-table-column label="可用配额" prop="availableQuota" />
          <el-table-column label="所在仓库" prop="warehouseName" />
          <el-table-column label="起始时间">
            <template slot-scope="scope">
              {{ scope.row.quotaDTO.effectiveDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column label="截止时间">
            <template slot-scope="scope">
              {{ scope.row.quotaDTO.expireDate | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="150"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <i
                  class="iconfont iconzu19 cursor"
                  v-if="scope.row.availableQuota > 0"
                  @click="handleAddCart(scope.row)"
                  title="加入购物车"
                />
                <i
                  class="el-icon-shopping-bag-1 cursor"
                  v-if="scope.row.availableQuota > 0"
                  @click="handleOrderNow(scope.row)"
                  title="立即下单"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { commonUtils } from '@/utils/common'
export default {
  name: 'stock-quota',
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        warehouseIds: '',
        itemName: '',
        itemCode: '',
        quotaName: '',
        fromDate: '',
        toDate: ''
      },
      warehouseList: [],
      dialogDetailVisible: false,
      total: 0,
      quotaList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      quotaTypeList: [],
      selectedQuota: []
    }
  },
  activated () {
    this.getQuotaList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getQuotaList()
      this.getWarehouseList()
    },

    // 获取配额列表
    getQuotaList () {
      this.loading = true
      this.$store
        .dispatch('queryQuotaList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.quotaList = res.data.resultData.stockQuotaList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 加入领用购物车
    handleAddCart (scope) {
      let params = {
        itemId: scope.itemId,
        moduleType: '02',
        itemQuantity: 1,
        warehouseId: scope.warehouseId,
        orgCode: scope.orgCode,
        buType: scope.buType,
        quotaId: scope.quotaId
      }
      this.loading = true
      this.$store
        .dispatch('addStockCart', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$message.success('商品加入购物车成功')
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('商品加入购物车失败')
        })
    },

    // 立即领用
    handleOrderNow (scope) {
      this.$confirm('是否确认单个商品立刻发货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$router.push({
            path: '/stock/fill-order',
            query: { type: 'quota', detailId: scope.detailId }
          })
        })
        .catch(() => {})
    },

    // 查询
    searchQuery () {
      this.getQuotaList()
    },

    // 重置
    resetQuery () {
      this.queryParam = {
        page: 1,
        pageSize: 10,
        warehouseIds: '',
        itemName: '',
        itemCode: '',
        quotaName: '',
        fromDate: '',
        toDate: ''
      }
      this.getQuotaList()
    },

    // 查看领用购物车
    searchStockCart () {
      this.$router.push({
        path: '/stock/cart',
        query: { moduleTypeName: 'quota' }
      })
    },
    // 查看领用订单
    goToQuotaOrder () {
      this.$router.push({
        path: '/stock/stock-quota-out'
      })
    },

    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseLists').then(response => {
        this.warehouseList = response.data.resultData.warehouseList
      })
    },
    handleViewPic (item) {
      window.open(this.getImageUrl(item))
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.itemImageUriList && item.itemImageUriList.length > 0) {
        imageUri = item.itemImageUriList[0]
      }
      return commonUtils.getImageUrl(imageUri)
    },

    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getBudgetList()
    },

    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.fromDate
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.toDate
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-line {
  padding-top:0;
}
.btn-line-right {
  text-align: right;
  margin-bottom: 10px;
}
.iconzu19,
.el-icon-shopping-bag-1 {
  font-size: 22px;
  color: $base-plain;
  margin-left: 20px;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
    cursor: pointer;
  }
}
</style>
